/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.OMS {
    import fld = ProcessInspectionRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ProcessInspectionEditor extends _Ext.ItemGridEditor<ProcessInspectionRow> {
        protected getColumnsKey() { return "OMS.ProcessInspection"; }
        protected getDialogType() { return ProcessInspectionDialog; }
        protected getLocalTextPrefix() { return ProcessInspectionRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        } 

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            //**** Master ****//
            buttons.push({
                title: "Select QC",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.QualityInspectionSelectGrid;
                    // **** Validate Party before Item Selection ****  
                    var filters: _Ext.SelectGridFilters = {

                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select QC", GridFilters:filters
                    });

                    pickerDialog.onSuccess = (selectedItems: Administration.QualityInspectionTemplateRow[]) => {
                        let selectedItems2 = selectedItems[0];
                        this.view.setItems([]);
                        for (var i = 0; i < selectedItems2.Details.length; i++) {
                            var qc = selectedItems2.Details[i];
                            var newqc: ProcessInspectionRow = {
                                IsNumeric: qc.IsNumeric,
                                Max: qc.Max,
                                Min: qc.Min,
                                Value: qc.Value,
                                Parameter: qc.Parameter,
                                TemplateId: qc.TemplateId
                            }
                            newqc[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(newqc);
                        }
                    }

                    pickerDialog.dialogOpen();
                },
            });
            return buttons;
        }

    }
}